module.exports = __webpack_public_path__ + "media/img/frontend_application/myhosting/pending-2c78649a75cc641054aa2cd9e493e688.png";